// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-food {
  height: 40vw;
  box-shadow: 3px 3px 25px -10px var(--ion-color-primary);
}
.selected-food .innerCard {
  height: 40vw;
}
.selected-food .innerCard .mcol {
  height: 40vw;
  min-width: 40vw;
}
.selected-food .innerCard .mcol .menuBgin {
  object-fit: cover;
  border-radius: 13px;
  max-height: 37vw;
  min-height: 37vw;
  max-width: 37vw;
  min-width: 37vw;
  top: 1.5vw;
  left: 1.5vw;
  box-shadow: var(--shadow-m);
}
.selected-food .innerCard .mcol .selImg {
  object-fit: cover;
  border-radius: 13px;
  max-height: 37vw;
  min-height: 37vw;
  max-width: 37vw;
  min-width: 37vw;
  top: 1.5vw;
  left: 1.5vw;
  opacity: 1;
}
.selected-food .innerCard .mcol .mealCounter {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0vw) scaleY(1) scaleX(1);
  transform-origin: center;
}
.selected-food .innerCard .mcol .typeTag {
  opacity: 1;
  scale: 1;
}
.selected-food .innerCard .contentInner {
  height: 40vw;
}
.selected-food .innerCard .contentInner .itemDetails .itemText .title {
  font-size: 14px;
}
.selected-food .innerCard .contentInner .itemDetails .itemText .desc {
  opacity: 1;
  max-height: calc(100% - 5vw);
}
.selected-food .innerCard .contentInner .itemDetails .price {
  scale: 1;
  background: var(--ion-color-success);
  color: var(--ion-text-success);
  border-radius: 20px;
  margin: 2vw;
}
.selected-food .innerCard .contentInner .itemDetails macros-bar {
  height: 5vw;
  margin-bottom: 2vw;
}
.selected-food .buttons {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  opacity: 1;
}
.selected-food .buttons .factor {
  border-radius: 10px;
  border: 0px solid;
  margin: 2px;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.unselected-food {
  height: 30vw;
}
.unselected-food .innerCard {
  height: 30vw;
}
.unselected-food .innerCard .mcol {
  height: 30vw;
  min-width: 30vw;
}
.unselected-food .innerCard .mcol .menuBgin {
  object-fit: cover;
  border-radius: 15px;
  max-height: 28vw;
  min-height: 28vw;
  max-width: 28vw;
  min-width: 28vw;
  top: 1vw;
  left: 1vw;
  box-shadow: none;
}
.unselected-food .innerCard .mcol .selImg {
  opacity: 1;
  object-fit: cover;
  border-radius: 15px;
  max-height: 28vw;
  min-height: 28vw;
  max-width: 28vw;
  min-width: 28vw;
  top: 1vw;
  left: 1vw;
}
.unselected-food .innerCard .mcol .mealCounter {
  opacity: 0;
  transform: translateY(-2vw) scaleY(0.2) scaleX(0.25);
  pointer-events: none;
  transform-origin: center;
}
.unselected-food .innerCard .mcol .typeTag {
  opacity: 0;
  scale: 1.15;
}
.unselected-food .innerCard .contentInner {
  height: 30vw;
}
.unselected-food .innerCard .contentInner .itemDetails .itemText .title {
  font-size: 14px;
}
.unselected-food .innerCard .contentInner .itemDetails .itemText .desc {
  opacity: 0;
  max-height: calc(0% - 0vw);
}
.unselected-food .innerCard .contentInner .itemDetails .price {
  scale: 0.9;
  background: var(--ion-color-secondary);
  color: var(--ion-text-secondary);
  border-radius: 10px;
  margin: 2vw;
}
.unselected-food .innerCard .contentInner .itemDetails macros-bar {
  height: 5vw;
  margin-bottom: 2vw;
}
.unselected-food .buttons {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: wrap;
  opacity: 0;
}
.unselected-food .buttons .factor {
  border-radius: 10px;
  border: 0px solid;
  margin: 2px;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.selected-food,
.unselected-food {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin: 0 auto;
  overflow: visible;
  min-width: 96vw;
  max-width: 96vw;
  border-radius: 15px;
  background: linear-gradient(90deg, hsl(var(--drop-bareLight-primary)/0.3) 0%, rgba(255, 255, 255, 0) 40%, #fff 65%, var(--ion-pass-primary) 100%);
  background-size: 200%;
  background-color: #fff;
  box-sizing: content-box;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard,
.unselected-food .innerCard {
  width: 100%;
  background: none;
  display: flex;
  margin: 0 auto;
  overflow: visible;
  justify-content: space-between;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol,
.unselected-food .innerCard .mcol {
  overflow: hidden;
  contain: content;
  border-radius: 13px;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .menuBgin,
.unselected-food .innerCard .mcol .menuBgin {
  margin: 0vw;
  position: absolute;
  z-index: 1;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .menuBgin .menuBginImg,
.unselected-food .innerCard .mcol .menuBgin .menuBginImg {
  margin: 0vw;
  position: absolute;
  top: -5vw;
  left: -5vw;
  height: 50vw;
  width: 50vw;
  background-image: url('bgMenu.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-color: transparent;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .selImg,
.unselected-food .innerCard .mcol .selImg {
  margin: 0vw;
  position: absolute;
  z-index: 2;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .mealCounter,
.unselected-food .innerCard .mcol .mealCounter {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  position: absolute;
  transform-origin: bottom;
  z-index: 2;
  background: transparent;
  bottom: 4vw;
  pointer-events: auto;
  margin: 0;
  border-radius: 15px;
  left: 4vw;
  width: 32vw;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .mealCounter .counterBg,
.unselected-food .innerCard .mcol .mealCounter .counterBg {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  position: absolute;
  transform-origin: bottom;
  z-index: 0;
  background: var(--ion-diffuseLight-primary);
  bottom: 0vw;
  pointer-events: auto;
  margin: 0;
  border-radius: 15px;
  left: 0vw;
  width: 32vw;
  height: 7vw;
  box-shadow: var(--shadow-m);
}
.selected-food .innerCard .mcol .mealCounter .addCounter,
.unselected-food .innerCard .mcol .mealCounter .addCounter {
  height: 5vw;
  width: 30%;
  margin: 1vw;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0.5vw;
  background: var(--ion-color-primary);
  border-radius: 13px;
  justify-content: center;
  z-index: 1;
  box-shadow: var(--shadow-m);
}
.selected-food .innerCard .mcol .mealCounter .addCounter .smallIcon,
.unselected-food .innerCard .mcol .mealCounter .addCounter .smallIcon {
  stroke: var(--ion-text-primary);
}
.selected-food .innerCard .mcol .mealCounter .itemCount,
.unselected-food .innerCard .mcol .mealCounter .itemCount {
  margin: 0;
  font-size: 16px;
  text-align: center;
  border-radius: 5px;
  color: #000;
  z-index: 1;
}
.selected-food .innerCard .mcol .mealCounter .minusCounter,
.unselected-food .innerCard .mcol .mealCounter .minusCounter {
  z-index: 1;
  height: 5vw;
  width: 30%;
  margin: 1vw;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0.5vw;
  background: var(--ion-color-primary);
  border-radius: 13px;
  justify-content: center;
  box-shadow: var(--shadow-m);
}
.selected-food .innerCard .mcol .mealCounter .minusCounter .smallIcon,
.unselected-food .innerCard .mcol .mealCounter .minusCounter .smallIcon {
  stroke: var(--ion-text-primary);
}
.selected-food .innerCard .mcol .typeTag,
.unselected-food .innerCard .mcol .typeTag {
  padding: 0px;
  margin: 0px;
  background: none;
  position: absolute;
  z-index: 2;
  top: 4vw;
  left: 4vw;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: var(--shadow-m);
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .mcol .typeTag .mealType,
.unselected-food .innerCard .mcol .typeTag .mealType {
  padding: 0 1.5vw;
  margin: 0vw;
  background: var(--ion-diffuseLight-primary);
  min-height: 3vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-food .innerCard .mcol .typeTag .mealType .mealText,
.unselected-food .innerCard .mcol .typeTag .mealType .mealText {
  font-size: 12px;
  color: #000;
  padding: 0 1vw;
}
.selected-food .innerCard .mcol .typeTag .price,
.unselected-food .innerCard .mcol .typeTag .price {
  height: 5vw;
  scale: 1;
  background: var(--ion-color-secondary);
  color: var(--ion-text-secondary);
  border-radius: 15px;
  padding: 0 1vw;
}
.selected-food .innerCard .contentInner,
.unselected-food .innerCard .contentInner {
  padding: 0;
  background: transparent;
  display: flex;
  overflow: auto;
  position: relative;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  flex-direction: row;
  width: 100%;
}
.selected-food .innerCard .contentInner .itemDetails,
.unselected-food .innerCard .contentInner .itemDetails {
  margin: 0vw;
  padding: 0;
  background: none;
  display: flex;
  transition: all 0.5s ease-in-out;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
}
.selected-food .innerCard .contentInner .itemDetails .itemText,
.unselected-food .innerCard .contentInner .itemDetails .itemText {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  margin: 0;
  padding: 0;
  width: 100%;
  height: calc(100% - 5vw);
}
.selected-food .innerCard .contentInner .itemDetails .itemText .title,
.unselected-food .innerCard .contentInner .itemDetails .itemText .title {
  white-space: normal;
  letter-spacing: 1px;
  color: var(--ion-black-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.5s ease-in-out;
  padding: 1vw;
  overflow: auto;
  margin: 0;
  min-height: 5vw;
}
.selected-food .innerCard .contentInner .itemDetails .itemText .desc,
.unselected-food .innerCard .contentInner .itemDetails .itemText .desc {
  white-space: normal;
  color: var(--ion-black-primary);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 90%;
  font-weight: 300;
  text-align: center;
  transition: all 0.5s ease-in-out;
  overflow: auto;
  font-size: 12px;
}
.selected-food .innerCard .contentInner .itemDetails .price,
.unselected-food .innerCard .contentInner .itemDetails .price {
  height: 7vw;
  padding: 1vw 3vw;
  font-size: 14px;
  width: fit-content;
  margin: 2vw;
  align-self: flex-end;
  transition: all 0.5s ease-in-out;
}
.selected-food .innerCard .contentInner .itemDetails macros-bar,
.unselected-food .innerCard .contentInner .itemDetails macros-bar {
  height: 5vw;
  margin-bottom: 2vw;
}

:host {
  display: flex;
  height: 100%;
  background: transparent;
}

.allergyPop:host .selected-food {
  box-shadow: 2px 2px 25px -15px var(--ion-darker-danger);
  border: 1px solid var(--ion-color-danger);
  background: linear-gradient(90deg, hsl(var(--drop-washed-primary)/0.3) 0%, #fff 40%, rgba(255, 255, 255, 0) 65%, var(--ion-pass-danger) 100%);
}

.allergyPop:host .unselected-food {
  border: 1px solid var(--ion-bareLight-danger);
  background: linear-gradient(-90deg, hsl(var(--drop-washed-primary)/0.3) 0%, #fff 40%, #fff 65%, var(--ion-pass-danger) 100%);
}

.normal:host .selected-food {
  box-shadow: 2px 2px 25px -15px var(--ion-darker-primary);
  border: 0px solid var(--ion-half-primary);
  background: linear-gradient(90deg, hsl(var(--drop-color-primary)/1) 0%, var(--ion-pass-primary) 40%, hsl(var(--drop-color-white)/1) 65%, var(--ion-color-white) 100%);
  background-size: 200%;
  background-position: 30%;
}
.normal:host .selected-food .innerCard .mcol .selImg {
  border: 1px solid var(--ion-half-primary);
}

.normal:host .unselected-food {
  box-shadow: 0.2px 0.2px 2.5px -1.5px var(--ion-darker-primary);
  background: linear-gradient(90deg, hsl(var(--drop-color-primary)/1) 0%, var(--ion-pass-primary) 40%, hsl(var(--drop-color-white)/1) 65%, var(--ion-color-white) 100%);
  background-size: 200%;
  background-position: 70%;
  border: 0px solid var(--ion-pass-primary);
}
.normal:host .unselected-food .innerCard .mcol .selImg {
  border: 1px solid var(--ion-bareLight-primary);
}

* {
  font-family: var(--ion-font-family);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-item/menu-item.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EAEA,uDAAA;AAAD;AAEC;EACC,YAAA;AAAF;AAEE;EACC,YAAA;EACA,eAAA;AAAH;AAEG;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EAEA,2BAAA;AADJ;AAKG;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAHJ;AAMG;EACC,UAAA;EACA,mBAAA;EACA,8CAAA;EACA,wBAAA;AAJJ;AAOG;EACC,UAAA;EACA,QAAA;AALJ;AASE;EACC,YAAA;AAPH;AAaK;EACC,eAAA;AAXN;AAcK;EACC,UAAA;EACA,4BAAA;AAZN;AAiBI;EACC,QAAA;EACA,oCAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAfL;AAkBI;EAEC,WAAA;EACA,kBAAA;AAjBL;AAwBC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAtBF;AAwBE;EACC,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAtBH;;AA6BA;EACC,YAAA;AA1BD;AA8BC;EACC,YAAA;AA5BF;AA8BE;EACC,YAAA;EACA,eAAA;AA5BH;AA8BG;EACC,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AA5BJ;AA+BG;EACC,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AA7BJ;AAgCG;EACC,UAAA;EACA,oDAAA;EACA,oBAAA;EACA,wBAAA;AA9BJ;AAiCG;EACC,UAAA;EACA,WAAA;AA/BJ;AAmCE;EACC,YAAA;AAjCH;AAuCK;EACC,eAAA;AArCN;AAwCK;EACC,UAAA;EACA,0BAAA;AAtCN;AA0CI;EACC,UAAA;EACA,sCAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AAxCL;AA2CI;EAEC,WAAA;EACA,kBAAA;AA1CL;AAkDC;EACC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAhDF;AAkDE;EACC,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAhDH;;AAuDA;;EAEC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,iJAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;AApDD;AAsDC;;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,cAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;AApDF;AAsDE;;EACC,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAnDH;AAqDG;;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gCAAA;AAlDJ;AAoDI;;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gCAAA;AAjDL;AAsDG;;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AAnDJ;AAuDG;;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;AApDJ;AAsDI;;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,2CAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;AAnDL;AAuDI;;EAEC,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,2BAAA;AArDL;AAuDK;;EACC,+BAAA;AApDN;AA0DI;;EAEC,SAAA;EACA,eAAA;EACA,kBAAA;EAEA,kBAAA;EACA,WAAA;EACA,UAAA;AAzDL;AA4DI;;EAEC,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AA1DL;AA4DK;;EACC,+BAAA;AAzDN;AAgEG;;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gCAAA;AA7DJ;AA+DI;;EACC,gBAAA;EACA,WAAA;EACA,2CAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA5DL;AA8DK;;EACC,eAAA;EACA,WAAA;EACA,cAAA;AA3DN;AAiEI;;EACC,WAAA;EACA,QAAA;EACA,sCAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;AA9DL;AAkFE;;EACC,UAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AA/EH;AAiFG;;EACC,WAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AA9EJ;AAgFI;;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;AA7EL;AA+EK;;EACC,mBAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AA5EN;AAgFK;;EACC,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EAEA,eAAA;AA9EN;AAkFI;;EACC,WAAA;EACA,gBAAA;EACA,eAAA;EAEA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,gCAAA;AA/EL;AAkFI;;EAEC,WAAA;EACA,kBAAA;AAhFL;;AAyFA;EACC,aAAA;EACA,YAAA;EACA,uBAAA;AAtFD;;AA0FC;EACC,uDAAA;EACA,yCAAA;EACA,6IAAA;AAvFF;;AA4FC;EACC,6CAAA;EACA,4HAAA;AAzFF;;AA8FC;EACC,wDAAA;EACA,yCAAA;EACA,qKAAA;EACA,qBAAA;EACA,wBAAA;AA3FF;AA+FI;EACC,yCAAA;AA7FL;;AAqGC;EACC,8DAAA;EACA,qKAAA;EACA,qBAAA;EACA,wBAAA;EACA,yCAAA;AAlGF;AAsGI;EACC,8CAAA;AApGL;;AA2GA;EACC,mCAAA;AAxGD","sourcesContent":[".selected-food {\n\theight: 40vw;\n\n\tbox-shadow: 3px 3px 25px -10px var(--ion-color-primary);\n\n\t.innerCard {\n\t\theight: 40vw;\n\n\t\t.mcol {\n\t\t\theight: 40vw;\n\t\t\tmin-width: 40vw;\n\n\t\t\t.menuBgin {\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 13px;\n\t\t\t\tmax-height: 37vw;\n\t\t\t\tmin-height: 37vw;\n\t\t\t\tmax-width: 37vw;\n\t\t\t\tmin-width: 37vw;\n\t\t\t\ttop: 1.5vw;\n\t\t\t\tleft: 1.5vw;\n\t\t\t\t// opacity: 1;\n\t\t\t\tbox-shadow: var(--shadow-m);\n\n\t\t\t}\n\n\t\t\t.selImg {\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 13px;\n\t\t\t\tmax-height: 37vw;\n\t\t\t\tmin-height: 37vw;\n\t\t\t\tmax-width: 37vw;\n\t\t\t\tmin-width: 37vw;\n\t\t\t\ttop: 1.5vw;\n\t\t\t\tleft: 1.5vw;\n\t\t\t\topacity: 1;\n\t\t\t}\n\n\t\t\t.mealCounter {\n\t\t\t\topacity: 1;\n\t\t\t\tpointer-events: all;\n\t\t\t\ttransform: translateY(0vw) scaleY(1) scaleX(1);\n\t\t\t\ttransform-origin: center;\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\topacity: 1;\n\t\t\t\tscale: 1;\n\t\t\t}\n\t\t}\n\n\t\t.contentInner {\n\t\t\theight: 40vw;\n\n\t\t\t.itemDetails {\n\n\n\t\t\t\t.itemText {\n\t\t\t\t\t.title {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.desc {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\tmax-height: calc(100% - 5vw);\n\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.price {\n\t\t\t\t\tscale: 1;\n\t\t\t\t\tbackground: var(--ion-color-success);\n\t\t\t\t\tcolor: var(--ion-text-success);\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tmargin: 2vw;\n\t\t\t\t}\n\n\t\t\t\tmacros-bar {\n\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\tmargin-bottom: 2vw;\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n\n\t.buttons {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-content: center;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\topacity: 1;\n\n\t\t.factor {\n\t\t\tborder-radius: 10px;\n\t\t\tborder: 0px solid;\n\t\t\tmargin: 2px;\n\t\t\tpadding: 5px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-content: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\n}\n\n.unselected-food {\n\theight: 30vw;\n\t// box-shadow: var(--shadow-l);\n\t// box-shadow: 2px 2px 20px -10px #fff0;\n\n\t.innerCard {\n\t\theight: 30vw;\n\n\t\t.mcol {\n\t\t\theight: 30vw;\n\t\t\tmin-width: 30vw;\n\n\t\t\t.menuBgin {\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tmax-height: 28vw;\n\t\t\t\tmin-height: 28vw;\n\t\t\t\tmax-width: 28vw;\n\t\t\t\tmin-width: 28vw;\n\t\t\t\ttop: 1vw;\n\t\t\t\tleft: 1vw;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t.selImg {\n\t\t\t\topacity: 1;\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tmax-height: 28vw;\n\t\t\t\tmin-height: 28vw;\n\t\t\t\tmax-width: 28vw;\n\t\t\t\tmin-width: 28vw;\n\t\t\t\ttop: 1vw;\n\t\t\t\tleft: 1vw;\n\t\t\t}\n\n\t\t\t.mealCounter {\n\t\t\t\topacity: 0;\n\t\t\t\ttransform: translateY(-2vw) scaleY(0.2) scaleX(0.25);\n\t\t\t\tpointer-events: none;\n\t\t\t\ttransform-origin: center;\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\topacity: 0;\n\t\t\t\tscale: 1.15;\n\t\t\t}\n\t\t}\n\n\t\t.contentInner {\n\t\t\theight: 30vw;\n\n\t\t\t.itemDetails {\n\n\n\t\t\t\t.itemText {\n\t\t\t\t\t.title {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.desc {\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\tmax-height: calc(0% - 0vw);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.price {\n\t\t\t\t\tscale: 0.9;\n\t\t\t\t\tbackground: var(--ion-color-secondary);\n\t\t\t\t\tcolor: var(--ion-text-secondary);\n\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\tmargin: 2vw;\n\t\t\t\t}\n\n\t\t\t\tmacros-bar {\n\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\tmargin-bottom: 2vw;\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\n\t}\n\n\t.buttons {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-content: center;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\topacity: 0;\n\n\t\t.factor {\n\t\t\tborder-radius: 10px;\n\t\t\tborder: 0px solid;\n\t\t\tmargin: 2px;\n\t\t\tpadding: 5px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-content: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\n}\n\n.selected-food,\n.unselected-food {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\tpadding: 0;\n\tmargin: 0 auto;\n\toverflow: visible;\n\tmin-width: 96vw;\n\tmax-width: 96vw;\n\tborder-radius: 15px;\n\tbackground: linear-gradient(90deg, hsl(var(--drop-bareLight-primary)/0.3) 0%, #fff0 40%, #fff 65%, var(--ion-pass-primary) 100%);\n\tbackground-size: 200%;\n\tbackground-color: #fff;\n\tbox-sizing: content-box;\n\ttransition: all 0.5s ease-in-out;\n\n\t.innerCard {\n\t\twidth: 100%;\n\t\tbackground: none;\n\t\tdisplay: flex;\n\t\t// flex-direction: row;\n\t\tmargin: 0 auto;\n\t\toverflow: visible;\n\t\tjustify-content: space-between;\n\t\ttransition: all 0.5s ease-in-out;\n\n\t\t.mcol {\n\t\t\toverflow: hidden;\n\t\t\tcontain: content;\n\t\t\tborder-radius: 13px;\n\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t.menuBgin {\n\t\t\t\tmargin: 0vw;\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 1;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t\t.menuBginImg {\n\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: -5vw;\n\t\t\t\t\tleft: -5vw;\n\t\t\t\t\theight: 50vw;\n\t\t\t\t\twidth: 50vw;\n\t\t\t\t\tbackground-image: url(\"../../../assets/bgMenu.png\");\n\t\t\t\t\tbackground-size: contain;\n\t\t\t\t\tbackground-repeat: no-repeat;\n\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.selImg {\n\t\t\t\tmargin: 0vw;\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 2;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t}\n\n\t\t\t.mealCounter {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tjustify-items: center;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: absolute;\n\t\t\t\ttransform-origin: bottom;\n\t\t\t\tz-index: 2;\n\t\t\t\tbackground: transparent;\n\t\t\t\tbottom: 4vw;\n\t\t\t\tpointer-events: auto;\n\t\t\t\tmargin: 0;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tleft: 4vw;\n\t\t\t\twidth: 32vw;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t\t.counterBg {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\tjustify-items: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttransform-origin: bottom;\n\t\t\t\t\tz-index: 0;\n\t\t\t\t\tbackground: var(--ion-diffuseLight-primary);\n\t\t\t\t\tbottom: 0vw;\n\t\t\t\t\tpointer-events: auto;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tborder-radius: 15px;\n\t\t\t\t\tleft: 0vw;\n\t\t\t\t\twidth: 32vw;\n\t\t\t\t\theight: 7vw;\n\t\t\t\t\tbox-shadow: var(--shadow-m);\n\n\t\t\t\t}\n\n\t\t\t\t.addCounter {\n\t\t\t\t\t// for substraction\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\twidth: 30%;\n\t\t\t\t\tmargin: 1vw;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 0;\n\t\t\t\t\tpadding: 0.5vw;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 13px;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\tbox-shadow: var(--shadow-m);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-text-primary);\n\t\t\t\t\t}\n\n\n\t\t\t\t}\n\n\t\t\t\t.itemCount {\n\t\t\t\t\t// width: 100%;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\t// background: #0000008e;\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t\tcolor: #000;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\n\t\t\t\t.minusCounter {\n\t\t\t\t\t// for addition\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\twidth: 30%;\n\t\t\t\t\tmargin: 1vw;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 0;\n\t\t\t\t\tpadding: 0.5vw;\n\t\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\t\tborder-radius: 13px;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tbox-shadow: var(--shadow-m);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-text-primary);\n\t\t\t\t\t}\n\n\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\tpadding: 0px;\n\t\t\t\tmargin: 0px;\n\t\t\t\tbackground: none;\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 2;\n\t\t\t\ttop: 4vw;\n\t\t\t\tleft: 4vw;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\toverflow: hidden;\n\t\t\t\tbox-shadow: var(--shadow-m);\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\n\t\t\t\t.mealType {\n\t\t\t\t\tpadding: 0 1.5vw;\n\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\tbackground: var(--ion-diffuseLight-primary);\n\t\t\t\t\tmin-height: 3vw;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t.mealText {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t\tpadding: 0 1vw;\n\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\t\t\t\t.price {\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\tscale: 1;\n\t\t\t\t\tbackground: var(--ion-color-secondary);\n\t\t\t\t\tcolor: var(--ion-text-secondary);\n\t\t\t\t\tborder-radius: 15px;\n\t\t\t\t\tpadding: 0 1vw;\n\t\t\t\t}\n\n\t\t\t\t// .price {\n\t\t\t\t// display: flex;\n\t\t\t\t// flex-direction: row;\n\t\t\t\t// align-items: center;\n\t\t\t\t// overflow: hidden;\n\t\t\t\t// justify-content: center;\n\t\t\t\t// filter: drop-shadow(1px 1px 2px var(--ion-color-grey));\n\t\t\t\t// transition: all 0.5s ease-in-out;\n\t\t\t\t// opacity: 0.8;\n\t\t\t\t// }\n\n\n\n\n\t\t\t}\n\t\t}\n\n\t\t.contentInner {\n\t\t\tpadding: 0;\n\t\t\tbackground: transparent;\n\t\t\tdisplay: flex;\n\t\t\toverflow: auto;\n\t\t\tposition: relative;\n\t\t\tjustify-content: center;\n\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\tflex-direction: row;\n\t\t\twidth: 100%;\n\n\t\t\t.itemDetails {\n\t\t\t\tmargin: 0vw;\n\t\t\t\tpadding: 0;\n\t\t\t\tbackground: none;\n\t\t\t\tdisplay: flex;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\tflex-direction: column;\n\t\t\t\theight: 100%;\n\n\t\t\t\t.itemText {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: calc(100% - 5vw);\n\n\t\t\t\t\t.title {\n\t\t\t\t\t\twhite-space: normal;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\t\tpadding: 1vw;\n\t\t\t\t\t\toverflow: auto;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tmin-height: 5vw;\n\n\t\t\t\t\t}\n\n\t\t\t\t\t.desc {\n\t\t\t\t\t\twhite-space: normal;\n\t\t\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\twidth: 90%;\n\t\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\t\toverflow: auto;\n\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.price {\n\t\t\t\t\theight: 7vw;\n\t\t\t\t\tpadding: 1vw 3vw;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\twidth: -moz-fit-content;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t\tmargin: 2vw;\n\t\t\t\t\talign-self: flex-end;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t}\n\n\t\t\t\tmacros-bar {\n\n\t\t\t\t\theight: 5vw;\n\t\t\t\t\tmargin-bottom: 2vw;\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n:host {\n\tdisplay: flex;\n\theight: 100%;\n\tbackground: transparent;\n}\n\n.allergyPop:host {\n\t.selected-food {\n\t\tbox-shadow: 2px 2px 25px -15px var(--ion-darker-danger);\n\t\tborder: 1px solid var(--ion-color-danger);\n\t\tbackground: linear-gradient(90deg, hsl(var(--drop-washed-primary)/0.3) 0%, #fff 40%, #fff0 65%, var(--ion-pass-danger) 100%);\n\t}\n}\n\n.allergyPop:host {\n\t.unselected-food {\n\t\tborder: 1px solid var(--ion-bareLight-danger);\n\t\tbackground: linear-gradient(-90deg, hsl(var(--drop-washed-primary)/0.3) 0%, #fff 40%, #fff 65%, var(--ion-pass-danger) 100%);\n\t}\n}\n\n.normal:host {\n\t.selected-food {\n\t\tbox-shadow: 2px 2px 25px -15px var(--ion-darker-primary);\n\t\tborder: 0px solid var(--ion-half-primary);\n\t\tbackground: linear-gradient(90deg, hsl(var(--drop-color-primary) / 1) 0%, var(--ion-pass-primary) 40%, hsl(var(--drop-color-white) / 1) 65%, var(--ion-color-white) 100%);\n\t\tbackground-size: 200%;\n\t\tbackground-position: 30%;\n\n\t\t.innerCard {\n\t\t\t.mcol {\n\t\t\t\t.selImg {\n\t\t\t\t\tborder: 1px solid var(--ion-half-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.normal:host {\n\t.unselected-food {\n\t\tbox-shadow: 0.2px 0.2px 2.5px -1.5px var(--ion-darker-primary);\n\t\tbackground: linear-gradient(90deg, hsl(var(--drop-color-primary) / 1) 0%, var(--ion-pass-primary) 40%, hsl(var(--drop-color-white) / 1) 65%, var(--ion-color-white) 100%);\n\t\tbackground-size: 200%;\n\t\tbackground-position: 70%;\n\t\tborder: 0px solid var(--ion-pass-primary);\n\n\t\t.innerCard {\n\t\t\t.mcol {\n\t\t\t\t.selImg {\n\t\t\t\t\tborder: 1px solid var(--ion-bareLight-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n* {\n\tfont-family: var(--ion-font-family);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
